import api from './api';

export const getPersonas = (params = {}) => {
  const { skip = 0, limit = 100, token_id } = params;
  let url = `/personas/?skip=${skip}&limit=${limit}`;
  
  if (token_id !== undefined) {
    url += `&token_id=${token_id}`;
  }
  
  return api.get(url);
};

export const getPersona = (id) => api.get(`/personas/${id}`);

export const createPersona = (personaData) => api.post('/personas/', personaData);

export const updatePersona = (id, personaData) => api.put(`/personas/${id}`, personaData);

export const deletePersona = (id) => api.delete(`/personas/${id}`);

export const getPersonaByTokenId = (tokenId) => 
  api.get(`/personas/token/${tokenId}`)
    .then(response => response.data)
    .catch(error => {
      if (error.response?.status === 404) {
        return null; // Return null instead of throwing error
      }
      throw error; // Re-throw other errors
    });